// utils/roleChecks.js
import { supabase } from "../lib/supabase";
import { USER_CATEGORY } from "utils/userCategoryEnum";

/**
 * Returns true if the given user is an active Admin in the given org.
 */
export const isOrgAdmin = async (userId, organizationId) => {
  const { data, error } = await supabase
    .from("user_org_memberships")
    .select("user_category_id")
    .eq("user_id", userId)
    .eq("organization_id", organizationId)
    .eq("is_active", 0) // 0 = active, per your existing convention
    .eq("user_category_id", USER_CATEGORY.ADMIN)
    .maybeSingle();

  if (error) throw error;
  return !!data;
};
